/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { RedlineFeaturePayload } from './redlineMarkup.model';

export class LoadRedlineMarkupConfig {
    static readonly type = '[RedlineMarkup] Load config';

    constructor(public mapName: string) {}
}

export class SetCurrentRedlineMarkupLayer {
    static readonly type = '[RedlineMarkup] Set current layer';

    constructor(public layer: string) {}
}

export class MergeRedlineFeatures {
    static readonly type = '[RedlineMarkup] Merge redline features';

    constructor(public payload: RedlineFeaturePayload) {}
}
